import * as _ from "lodash";

import { Base64 } from "js-base64";
import fetch from "node-fetch";
import qs from "qs";

// import * as http from "http";

export default class BudgeaAPI {
  settings = {};
  access_token = "";
  access_token_type = "bearer"; // default token type is Bearer

  constructor(domain, settings = {}) {
    this.settings["authorization_endpoint"] = "/auth/webview/accounts/";
    // this.settings["authorization_endpoint"] = "/auth/webview/connect/select/";
    this.settings["token_endpoint"] = "/auth/token/access";

    this.settings["code_endpoint"] = "/auth/token/code";
    this.settings["base_url"] = "https://" + domain + "/2.0";
    this.settings["http_headers"] = {};
    this.settings["client_id"] = undefined;
    this.settings["client_secret"] = undefined;
    this.settings["access_token_param_name"] = "token";
    this.settings["transfers_endpoint"] = "/webview/transfers/accounts";

    _.mergeWith(this.settings, settings);
    console.log("BudgeaClient", domain);
  }

  setClientId = client_id => {
    this.settings["client_id"] = client_id;
  };

  setClientSecret = client_secret => {
    this.settings["client_secret"] = client_secret;
  };
  /**
   * @param $token
   */
  setAccessToken = token => {
    this.access_token = token;
  };
  /**
   * @return mixed
   */
  getAccessToken = () => {
    return this.access_token;
  };

  get = async (resourceUrl, parameters = undefined) => {
    return await this.fetch(resourceUrl, parameters);
  };

  getAccounts = async (expand = "") => {
    // if(!empty($expand)){
    //     $expandArray = array('expand' => $expand);
    // } else {
    //     $expandArray = array();
    // }
    let expandArray = !!expand ? { expand } : undefined;

    const res = await this.get("/users/me/accounts", expandArray);
    console.log("getAccounts res", res);
    return res["accounts"];
  };
  /*
  public function getSettingsUrl($state = '') {
    $response = $this->fetch($this->settings['code_endpoint']);
    $parameters = array(
        'response_type' => 'code',
        'client_id' => $this->settings['client_id'],
        'state' => $state,
    );
    if(isset($this->settings['redirect_uri'])){
        $params['redirect_uri'] = $this->settings['redirect_uri'];
    }
    return $this->absurl($this->settings['authorization_endpoint'] . '?' . http_build_query($parameters, null, '&').'#'.$response['code']);
  }
  */

  /**
   * @param string $state
   * @return string
   */
  getSettingsUrl = async (state = "") => {
    console.log("getSettingsUrl", this.settings);
    const response = await this.fetch(this.settings["code_endpoint"]);
    console.log("getSettingsUrl response", response);
    const params = {
      // response_type: "code",
      client_id: process.env.REACT_APP_BUDGEA_CLIENT_ID,
      redirect_uri: this.settings["redirect_uri"],
      state: state
    };

    if (this.settings["redirect_uri"]) {
      params["redirect_uri"] = this.settings["redirect_uri"];
    }

    // return $this->absurl($this->settings['authorization_endpoint'] . '?' . http_build_query($parameters, null, '&').'#'.$response['code']);

    const query = qs.stringify(params);
    const code = response["code"];
    const url = this.absurl(
      `${this.settings["authorization_endpoint"]}?${query}#${code}`
    );
    console.log("codeurl", url);
    return url;
  };
  /**
   * @param string $state
   * @return string
   */
  getAuthenticationUrl = (state = "") => {
    const params = {
      response_type: "code",
      client_id: this.settings["client_id"],
      redirect_uri: this.settings["redirect_uri"],
      state: state
    };

    if (this.settings["redirect_uri"]) {
      params["redirect_uri"] = this.settings["redirect_uri"];
    }

    const query = qs.stringify(params);
    return this.absurl(`${this.settings["authorization_endpoint"]}?${query}`);
  };

  absurl = url => {
    if (url.startsWith("/")) {
      url = this.settings["base_url"] + url;
    }
    return url;
  };

  /**
   * @param null $state
   * @return bool
   * @throws AuthFailed
   * @throws ConnectionError
   * @throws StateInvalid
   */
  handleCallback = async (params, state = null) => {
    console.log("handleCallback", params, state);
    if (params["error"]) {
      console.log("handleCallback errors", params["error"]);
      //throw new AuthFailed(params["error"]);
    }

    console.log("handleCallback1", params["code"]);
    if (!params["code"]) return false;
    if (
      (state !== undefined && !params["state"]) ||
      params["state"] !== state
    ) {
      console.log("handleCallback invalid state: ", state, params["state"]);
      throw new StateInvalid("invalid state");
    }
    params = { code: params["code"] };

    if (this.settings["redirect_uri"]) {
      params["redirect_uri"] = this.settings["redirect_uri"];
    }
    params["grant_type"] = "authorization_code";
    let http_headers = {};
    http_headers["Authorization"] =
      "Basic " +
      Base64.encode(
        this.settings["client_id"] + ":" + this.settings["client_secret"]
      );

    console.log(
      "fetch()",
      this.settings["token_endpoint"],
      params,
      http_headers
    );
    try {
      const response = await this.fetch(
        this.settings["token_endpoint"],
        params,
        "POST",
        http_headers
      );
      console.log("fetch response", response);
      this.access_token = response["access_token"];
      this.access_token_type = response["token_type"].toLowerCase();

      console.log("atoken", response["access_token"]);
      return state || true;
    } catch (e) {
      console.log("fetch error", e);
      throw e;
    }

    // const urlParams = new URLSearchParams(params);
    // console.log("params", params);
    // const fetch_args = {
    //   method: "POST",
    //   headers: http_headers,
    //   body: urlParams
    // };
    // console.log("fetch_args", fetch_args);
    // console.log("fetch");
    // let res = await fetch(
    //   this.absurl(this.settings["token_endpoint"]),
    //   fetch_args
    // );
    // const response = await res.json();
    // console.log("fetch response", res, JSON.stringify(response));

    // const response = this.executeRequest(
    //   this.settings["token_endpoint"],
    //   params,
    //   "POST",
    //   http_headers
    // );

    // if (!res.ok) return false; // throw new AuthFailed(response.error);
  };

  // fetch helper
  fetch = async (
    url,
    parameters = undefined,
    method = "GET",
    http_headers = {}
  ) => {
    console.log("fetch token:", this.access_token);
    http_headers = { ...this.settings["http_headers"], ...http_headers };
    let absUrl = this.absurl(url);

    if (this.access_token) {
      console.log("have access token");
      switch (this.access_token_type) {
        case "url": {
          console.log("url");
          if (parameters) {
            parameters[
              this.settings["access_token_param_name"]
            ] = this.access_token;
          } else {
            throw new RequireParamsAsArray(
              "You need to give parameters as array if you want to give the token within the URI."
            );
          }
          break;
        }
        case "bearer":
          console.log("bearer");
          http_headers["Authorization"] = "Bearer " + this.access_token;
          break;
        case "oauth":
          console.log("oauth");
          http_headers["Authorization"] = "OAuth " + this.access_token;
          break;
        default:
          throw new InvalidAccessTokenType("invalid access");
      }
    }

    const fetch_args = {
      method: method,
      headers: http_headers
      // mode: "no-cors"
    };
    if (parameters && method === "POST") {
      fetch_args.body = new URLSearchParams(parameters);
    }
    if (parameters && method === "GET") {
      const query = qs.stringify(parameters);
      absUrl = `${absUrl}?${query}`;
    }

    console.log("nodefetch", absUrl, fetch_args);
    let res = await fetch(absUrl, fetch_args);

    console.log("fetch res", res, res.status);
    switch (res.status) {
      case 200:
        const response = await res.json();
        return response;
      case 400:
        throw new BadAccess("bad access");
      case 401:
      case 403:
        throw new AuthRequired("auth required");
      default:
    }
    return res;
  };
}

export class Exception extends Error {}
export class ConnectionError extends Error {
  constructor(message) {
    super(message);
    this.name = "ConnectionError";
  }
}
export class InvalidAccessTokenType extends Error {
  constructor(message) {
    super(message);
    this.name = "InvalidAccessTokenType";
  }
}
export class NoPermission extends Error {
  constructor(message) {
    super(message);
    this.name = "NoPermission";
  }
}
export class AuthRequired extends Error {
  constructor(message) {
    super(message);
    this.name = "AuthRequired";
  }
}
export class AuthFailed extends Error {
  constructor(message) {
    super(message);
    this.name = "AuthFailed";
  }
}
export class BadAccess extends Error {
  constructor(message) {
    super(message);
    this.name = "BadAccess";
  }
}
export class StateInvalid extends Error {
  constructor(message) {
    super(message);
    this.name = "StateInvalid";
  }
}
export class RequireParamsAsArray extends Error {
  constructor(message) {
    super(message);
    this.name = "RequireParamsAsArray";
  }
}
